import React from 'react';
import DatePicker from 'react-datepicker';
import {FormGroup} from '../form-features/FormGroup';
import {FormLabel} from '../form-features/FormLabel';
import {FormInputContainer} from './FormInput';
import styled from 'styled-components';
import {ErrorMessage} from 'formik';
import {ValidationErrorTxt} from '../form-features/ValidationErrorTxt';

export const FormDatePicker = function ({
    label,
    name,
    disabled = false,
    prefixIcon,
    suffixIcon,
    size,
    borderError,
    ...props
}) {
    return (
        <FormGroup>
            {label && <FormLabel>{label}</FormLabel>}
            <div>
                <FormInputContainer size={size} disabled={disabled} suffixIcon={suffixIcon} prefixIcon={prefixIcon}>
                    <Wrapper>
                        <DatePicker {...props} />
                    </Wrapper>
                </FormInputContainer>
                {!borderError && (
                    <ErrorMessage name={name}>
                        {(msg) => {
                            return <ValidationErrorTxt>{msg}</ValidationErrorTxt>;
                        }}
                    </ErrorMessage>
                )}
            </div>
        </FormGroup>
    );
};

const Wrapper = styled.div`
    height: 100%;
    .react-datepicker-wrapper,
    .react-datepicker__input-container,
    input {
        width: 100%;
        height: 100%;
    }
    .react-datepicker-popper {
        width: 350px;
    }
`;
